import React from 'react'
import { FormattedMessage } from 'react-intl'
import { REFI_DETAILS_HEADLINE } from 'src/constants/refinance'
import { Text } from 'src/Components'
import Format from 'src/Components/shared/Format'
import PropTypes from 'prop-types'
import { baseProps, deltaProps } from './Shapes'

const getLongTermVariant = amount => {
  if (amount >= 0) {
    return 'success'
  }
  return 'danger'
}

const getShortTermVariant = amount => {
  if (amount <= 0) {
    return 'success'
  }
  return 'danger'
}

const DetailsHeadline = ({ years, longterm, shortterm }) => {
  let key

  if (longterm > 0 && shortterm <= 0) {
    key = 'longTermSavings_monthlySavings'
  } else if (longterm > 0) {
    key = 'longTermSavings_monthlyLoss'
  } else if (shortterm < 0) {
    key = 'longTermLoss_monthlySavings'
  } else if (longterm === 0 && shortterm === 0) {
    key = 'noSavings'
  } else {
    key = 'longTermLoss_monthlyLoss'
  }

  const headlineMessage = REFI_DETAILS_HEADLINE[key]

  return (
    <FormattedMessage
      {...headlineMessage}
      values={{
        years,
        abs_shortTerm: <ShortTermAmount shortterm={shortterm} />,
        abs_longTerm: <LongTermAmount longterm={longterm} />,
      }}
    />
  )
}

const LongTermAmount = ({ longterm }) => {
  const variant = getLongTermVariant(longterm)

  return (
    <Text element='span' variant={variant}>
      <Format.Currency abbreviate value={Math.abs(longterm)} />
    </Text>
  )
}

const ShortTermAmount = ({ shortterm }) => {
  const variant = getShortTermVariant(shortterm)

  return (
    <Text element='span' variant={variant}>
      <Format.Currency value={Math.abs(shortterm)} />
      /mo
    </Text>
  )
}

DetailsHeadline.propTypes = {
  ...baseProps,
  ...deltaProps,
}

LongTermAmount.propTypes = {
  longterm: PropTypes.number.isRequired,
}

ShortTermAmount.propTypes = {
  shortterm: PropTypes.number.isRequired,
}

export default DetailsHeadline
